import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Collapse, Table } from "antd";
import { Menu as MENU, X } from "react-feather";
import SideMenuBar from "./components/SideMenuBar";
import { toast } from "react-toastify";
import API_LINK from "../components/links/Link";
import $ from 'jquery';
import {
    ACCESSORIES_ICON_LARGE,
    INVERTER_ICON_LARGE,
    PANEL_ICON_LARGE,
    STORAGE_ICON_LARGE
} from "../assets/images/Images";

export default function Inventory() {
    const history = useHistory();
    const [moduleData, setModuleData] = useState([]);
    const [moduleFilter, setModuleFilter] = useState([]);
    const [inverterData, setInverterData] = useState([]);
    const [inverterFilter, setInverterFilter] = useState([]);
    const [energyStorageData, setEnergyStorageData] = useState([]);
    const [energyStorageFilter, setEnergyStorageFilter] = useState([]);
    const [accessoriesData, setAccessoriesData] = useState([]);
    const [accessoriesFilter, setAccessoriesFilter] = useState([]);
    // Manufacturer
    const [moduleManufacturer, setModuleManufacturer] = useState([]);
    const [inverterMan, setInverterMan] = useState([]);
    const [storageMan, setStorageMan] = useState([]);
    const [accessoriesMan, setAccessoriesMan] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isMobileShow, setIsMobileShow] = useState(false);

    const [sortedInfo, setSortedInfo] = useState({});

    const handleChange = (pagination, filters, sorter) => {
        setSortedInfo(sorter);
    };


    useEffect(() => {
        LoadModules();
        LoadInverter();
        LoadEnergyStorage();
        LoadAccessories();
    }, []);

    const LoadModules = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
            formdata.append("page", "LoadModules");
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Solar.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)

                    // console.log(uniqueManufacturers);
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            const uniqueManufacturers = result.data.reduce((acc, current) => {
                                // Check if the manufacturer is already in the accumulator
                                const x = acc.find(item => item.Manufacturer === current.Manufacturer);
                                // If not found, add the current item to the accumulator
                                if (!x) {
                                    acc.push(current);
                                }
                                return acc;
                            }, []);
                            setModuleManufacturer(uniqueManufacturers)
                            setModuleData(result.data);
                            setModuleFilter(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                    setIsLoading(false);
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }

    const LoadInverter = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
            formdata.append("page", "LoadInverters");
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Solar.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            const uniqueManufacturers = result.data.reduce((acc, current) => {
                                // Check if the manufacturer is already in the accumulator
                                const x = acc.find(item => item.Manufacturer === current.Manufacturer);
                                // If not found, add the current item to the accumulator
                                if (!x) {
                                    acc.push(current);
                                }
                                return acc;
                            }, []);
                            setInverterMan(uniqueManufacturers)
                            setInverterData(result.data);
                            setInverterFilter(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                    setIsLoading(false);
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }

    const LoadEnergyStorage = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
            formdata.append("page", "LoadEnergyStorage");
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Solar.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            const uniqueManufacturers = result.data.reduce((acc, current) => {
                                // Check if the manufacturer is already in the accumulator
                                const x = acc.find(item => item.Manufacturer === current.Manufacturer);
                                // If not found, add the current item to the accumulator
                                if (!x) {
                                    acc.push(current);
                                }
                                return acc;
                            }, []);
                            setStorageMan(uniqueManufacturers)
                            setEnergyStorageData(result.data);
                            setEnergyStorageFilter(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                    setIsLoading(false);
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }
    const LoadAccessories = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
            formdata.append("page", "LoadAccessories");
            var requestOptions = {
                method: 'POST', body: formdata, redirect: 'follow'
            };

            await fetch(`${API_LINK}Solar.php`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    console.log(result)
                    if (result.status === 1) {
                        if (result.data.length > 0) {
                            const uniqueManufacturers = result.data.reduce((acc, current) => {
                                // Check if the manufacturer is already in the accumulator
                                const x = acc.find(item => item.Manufacturer === current.Manufacturer);
                                // If not found, add the current item to the accumulator
                                if (!x) {
                                    acc.push(current);
                                }
                                return acc;
                            }, []);
                            setAccessoriesMan(uniqueManufacturers)
                            setAccessoriesData(result.data);
                            setAccessoriesFilter(result.data);
                        }
                    } else {
                        toast.error("Server Error! Please try again later.")
                    }
                    setIsLoading(false);
                }).catch(error => console.log('error', error));
        } catch (e) {
            console.log(e)
        }
    }
    // const handleSearch = (value) => {
    //     if (value) {
    //         const filtered = filterData.filter((item) => item.SKU.toLowerCase().includes(value.trim().toLowerCase()) || item.State.toLowerCase().includes(value.trim().toLowerCase()) || item.Manufacturer.toLowerCase().includes(value.trim().toLowerCase()));
    //         setUsersData(filtered);
    //     } else {
    //         setUsersData(filterData);
    //     }
    //
    // };

    const faqs = [
        {
            key: '1',
            label: <h4 style={{ fontWeight: 400, borderBottom: '1.2px solid #EFEFEF', paddingBottom: '10px', marginBottom: '10px' }}>What are my payment options?</h4>,
            children: <>
                <div style={{ paddingBottom: '15px', marginBottom: '15px' }}>
                    <p>We accept credit cards, direct debits, wire transfers, ACH bank-to-bank transfers, physical checks, Apple Pay, and Google Wallet. Paneldeals uses Stripe, a leading payment platform trusted by millions of brands around the world, to process payments made by credit card, ACH direct debit, Apple Pay, and Google Wallet. Stripe is certified to the highest compliance standards in the industry and is incredibly simple to use.</p>
                    <img style={{ width: '150px', display: 'block', paddingTop: '15px' }} src="https://paneldeals.com/PoweredByStripe-Badge-01.svg" />
                    <img style={{ width: '320px', display: 'block', paddingTop: '5px' }} src="https://paneldeals.com/Payment-Badges-01.svg" />
                </div>
            </>,
        },
        {
            key: '2',
            label: <h4 style={{ fontWeight: 400, borderBottom: '1.2px solid #EFEFEF', paddingBottom: '10px', marginBottom: '10px' }}>How soon will my order ship?</h4>,
            children: <>
                <div style={{ paddingBottom: '15px', marginBottom: '15px' }}>
                    <p>Items that are “Available Now” are in stock and ready to ship based on standard shipping processing times listed below.</p>
                    <table style={{
                        margin: '20px 0',
                        width: 'inherit',
                        tableLayout: "fixed",
                        borderCollapse: "collapse",
                        display: 'table',
                        textIndent: 'initial',
                        unicodeBidi: "isolate",
                        borderSpacing: "2px",
                        borderColor: "gray",
                        borderWidth: '1px',
                    }} className='faq-table'>
                        <tbody>
                            <tr>
                                <th style={{ backgroundColor: '#1d252c', color: '#fff' }}>Availability</th>
                                <th style={{ backgroundColor: '#1d252c', color: '#fff' }}>Payment Method</th>
                                <th style={{ backgroundColor: '#1d252c', color: '#fff' }}>Ships In</th>
                            </tr>
                            <tr>
                                <td rowSpan="3">Available Now</td>
                                <td>Credit card, ACH transfer, wire transfer</td>
                                <td>3-5 business days</td>
                            </tr>
                            <tr>
                                <td>ACH direct debit</td>
                                <td>6-10 business days</td>
                            </tr>
                            <tr>
                                <td>Physical check</td>
                                <td>7-14 business days</td>
                            </tr>
                            <tr style={{ border: '0' }}>
                                <td style={{ border: '0', fontSize: '9px' }} colSpan="3">There are many additional factors that impact processing and shipping times. These are estimates only.</td>
                            </tr>
                        </tbody>
                    </table>
                    <p><strong>We automatically hold your order for up to 72 hours for payment processing,</strong> unless otherwise specified on your sales order. Once the terms are satisfied, your order will be shipped as soon as possible or the date coordinated with your Paneldeals Sales Representative.</p>
                    <br />
                    <p><strong>Payment must be received before shipping. No exceptions.</strong></p>
                </div>
            </>,
        },
        {
            key: '4',
            label: <h4 style={{ fontWeight: 400, borderBottom: '1.2px solid #EFEFEF', paddingBottom: '10px', marginBottom: '10px' }}>Does Paneldeals Charge Sales Tax?</h4>,
            children: <>
                <div style={{ paddingBottom: '15px', marginBottom: '15px' }}>
                    <p>Yes, Paneldeals charges sales tax in states or jurisdictions where it has established nexus. To remove sales tax, you must provide a valid and complete resale certificate for the state or jurisdiction associated with the delivery address on your order. <strong>Please allow an additional 2 to 3 business days for us to process your request.</strong></p>
                </div>
            </>,
        },
        {
            key: '5',
            label: <h4 style={{ fontWeight: 400, borderBottom: '1.2px solid #EFEFEF', paddingBottom: '10px', marginBottom: '10px' }}>How do I place an order?</h4>,
            children: <>
                <div style={{ paddingBottom: '15px', marginBottom: '15px' }}>
                    <p>To place an order, email us with the SKUs and quantities you need, and a member of our sales team will reach out to you promptly. Please note that minimum order quantities (MOQs) apply in most cases.</p>
                </div>
            </>,
        },
        {
            key: '6',
            label: <h4 style={{ fontWeight: 400, borderBottom: '1.2px solid #EFEFEF', paddingBottom: '10px', marginBottom: '10px', zindex: '999999999' }}>Does Paneldeals break pallets?</h4>,
            children: <>
                <div style={{ paddingBottom: '15px', marginBottom: '15px' }}>
                    <p><strong>No, we do not break pallets, even for a fee.</strong> This policy helps us streamline our operations and keep costs as low as possible for our buyers. However, you may find less-than-full-pallet quantities among our clearance items.</p>
                </div>
            </>,
        },
        {
            key: '7',
            label: <h4 style={{ fontWeight: 400, borderBottom: '1.2px solid #EFEFEF', paddingBottom: '10px', marginBottom: '10px' }}>What if I need something that is not on the Inventory list?</h4>,
            children: <>
                <div style={{ paddingBottom: '15px', marginBottom: '15px' }}>
                    <p>Please let us know! Our team is here to assist you in finding what you’re looking for or to recommend suitable alternatives.</p>
                </div>
            </>,
        },
    ];


    return (<>
        <div className='dashboard-container'>
            <SideMenuBar mobileShow={isMobileShow} />
            <div className="dashboard-content" data-aos={'fade-left'}>
                <div className="content">
                    <button type={"button"} className='btn_dashboard_menu' onClick={() => setIsMobileShow(true)}>
                        <MENU size={16} />
                        <span>Show Menu</span>
                    </button>
                    <button type={"button"} className={`btn_dashboard_close_menu ${isMobileShow ? "show" : "hide"}`}
                        onClick={() => setIsMobileShow(false)}>
                        <X size={16} />
                    </button>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: '100px' }}>
                        <h2>Available Inventory</h2>
                        <small>Quality equipment at amazingly low prices, every day.</small>
                    </div>
                    <div className="cards-tabs centered-tabs">
                        <div className="card-tab" onClick={() => {
                            const section = document.getElementById('modules');
                            if (section) {
                                section.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}>
                            <img src={PANEL_ICON_LARGE} alt="" />
                            <p>Modules</p>
                        </div>
                        <div className="card-tab" onClick={() => {
                            const section = document.getElementById('inverters');
                            if (section) {
                                section.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}>
                            <img src={INVERTER_ICON_LARGE} alt="" />
                            <p>Inverters</p>
                        </div>
                        <div className="card-tab" onClick={() => {
                            const section = document.getElementById('storages');
                            if (section) {
                                section.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}>
                            <img src={STORAGE_ICON_LARGE} alt="" />
                            <p>Storage</p>
                        </div>
                        <div className="card-tab" onClick={() => {
                            const section = document.getElementById('accessories');
                            if (section) {
                                section.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}>
                            <img src={ACCESSORIES_ICON_LARGE} alt="" />
                            <p>Accessories</p>
                        </div>
                        <div className="card-tab" onClick={() => {
                            const section = document.getElementById('faqs');
                            if (section) {
                                section.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}>
                            <span>FAQs</span>
                        </div>
                        <div className="row" style={{
                            width: "100%",
                            justifyContent: "center",
                            textAlign: "center",
                            marginTop: 10,
                            fontSize: 11,
                            alignItems: "center"
                        }}>
                            <p><span><img draggable="false" role="img" className="emoji"
                                style={{ width: 15, height: 15, marginTop: 10 }}
                                alt="🇺🇸"
                                src="https://s.w.org/images/core/emoji/15.0.3/svg/1f1fa-1f1f8.svg" /></span> =
                                This icon appears next to products that are fully or partially made and assembled in the
                                USA.</p>
                        </div>
                    </div>

                    <div className="content-card" id='modules'>
                        <div className="table-search">
                            <div className="panel-card-heading">
                                <img src={PANEL_ICON_LARGE} alt="" />
                                <h2>PV Solar Modules</h2>
                            </div>
                        </div>
                        <div className="table-filter">
                            <div className="row">
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Manufacturer</label>
                                        <select name="manufacturer" id="manufacturer" onChange={(e) => {
                                            let value = e.target.value;
                                            if (value) {
                                                const filtered = moduleFilter.filter((item) => item.Manufacturer.toLowerCase().includes(value.trim().toLowerCase()));
                                                setModuleData(filtered);
                                            } else {
                                                setModuleData(moduleFilter)
                                            }
                                        }}>
                                            <option value="">All</option>
                                            {
                                                moduleManufacturer.map((m, i) => {
                                                    return (
                                                        <option value={m.Manufacturer}>{m.Manufacturer}</option>
                                                    )
                                                })
                                            }
                                            {/*<option value="First Solar">First Solar</option>*/}
                                            {/*<option value="JA Solar">JA Solar</option>*/}
                                            {/*<option value="LG">LG</option>*/}
                                            {/*<option value="Mission Solar">Mission Solar</option>*/}
                                            {/*<option value="Philadelphia Solar">Philadelphia Solar</option>*/}
                                            {/*<option value="Phono Solar">Phono Solar</option>*/}
                                            {/*<option value="Qcells">Qcells</option>*/}
                                            {/*<option value="REC">REC</option>*/}
                                            {/*<option value="Trina Solar">Trina Solar</option>*/}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Price Per Watt</label>
                                        <div className="row" style={{ marginTop: 0 }}>
                                            <input type="text" style={{ width: '48%', marginRight: '2%' }}
                                                id={'modulePriceMin'}
                                                placeholder={'min'} onChange={(e) => {
                                                    let min = e.target.value;
                                                    let max = $('#modulePriceMax').val();
                                                    if (min && max) {
                                                        const filtered = moduleFilter.filter((item) => parseFloat(item.PalletPrice.replace('$', '')) >= parseFloat(min) && parseFloat(item.PalletPrice.replace('$', '')) <= parseFloat(max));
                                                        setModuleData(filtered);
                                                    } else if (min) {
                                                        const filtered = moduleFilter.filter((item) => parseFloat(item.PalletPrice.replace('$', '')) >= parseFloat(min));
                                                        setModuleData(filtered);
                                                    }
                                                }} />
                                            <input type="text" style={{ width: '48%' }} id={'modulePriceMax'}
                                                placeholder={'max'} onChange={(e) => {
                                                    let max = e.target.value;
                                                    let min = $('#modulePriceMin').val();
                                                    if (min && max) {
                                                        const filtered = moduleFilter.filter((item) => parseFloat(item.PalletPrice.replace('$', '')) >= parseFloat(min) && parseFloat(item.PalletPrice.replace('$', '')) <= parseFloat(max));
                                                        setModuleData(filtered);
                                                    } else if (max) {
                                                        const filtered = moduleFilter.filter((item) => parseFloat(item.PalletPrice.replace('$', '')) >= parseFloat(max));
                                                        setModuleData(filtered);
                                                    }
                                                }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Additional Filters</label>
                                        <select name="additionalFilter" id="additionalFilter" onChange={(e) => {
                                            let value = e.target.value;
                                            if (value) {
                                                const filtered = moduleFilter.filter((item) => item.Availability.toLowerCase().includes(value.trim().toLowerCase()));
                                                setModuleData(filtered);
                                            } else {
                                                setModuleData(moduleFilter);
                                            }
                                        }}>
                                            <option value="">All</option>
                                            <option value="Available Now">Available Now</option>
                                            <option value="Last Stock">Last Stock</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>&nbsp;&nbsp;&nbsp;</label>
                                        <button className='btn-back-dashboard'
                                            onClick={() => {
                                                $('#modulePriceMin').val('');
                                                $('#modulePriceMax').val('');
                                                $('select[name="manufacturer"]').eq(0).val("");
                                                $('select[name="additionalFilter"]').eq(0).val("");
                                                setModuleData(moduleFilter)
                                            }}>Clear Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Table dataSource={moduleData} pagination={{ pageSize: 10 }}
                            loading={isLoading} onChange={handleChange} bordered
                            sortDirections={['ascend', 'descend']}
                            rowHoverable={true} style={{ marginTop: 20, overflowX: "auto" }}>
                            <Table.Column title="#" width={70} render={(j, r, index) => {
                                return (<span>{index + 1}</span>)
                            }} />

                            <Table.Column title="Manufacturer" dataIndex="Manufacturer"
                                sorter={(a, b) => a.Manufacturer.localeCompare(b.Manufacturer)} />
                            <Table.Column title="Manufacturer Part Number" dataIndex="PartNo"
                                sorter={(a, b) => a.PartNo.localeCompare(b.PartNo)} />
                            <Table.Column title="SKU" dataIndex="SKU" sorter={(a, b) => a.SKU.localeCompare(b.SKU)} />
                            <Table.Column title="Watt" dataIndex="Watt"
                                sorter={(a, b) => a.Watt.localeCompare(b.Watt)} />
                            <Table.Column title="Pallet Price" dataIndex="PalletPrice"
                                sorter={(a, b) => a.PalletPrice.localeCompare(b.PalletPrice)} />
                            <Table.Column title="Container Price" dataIndex="ContainerPrice"
                                sorter={(a, b) => a.ContainerPrice.localeCompare(b.ContainerPrice)} />
                            <Table.Column title="Module Quantity" dataIndex="ModuleQuantity"
                                sorter={(a, b) => a.ModuleQuantity.localeCompare(b.ModuleQuantity)} />
                            <Table.Column title="Pallet Remaining" dataIndex="Remaining"
                                sorter={(a, b) => a.Remaining.localeCompare(b.Remaining)} />
                            <Table.Column title="MOQ" dataIndex="MOQ" sorter={(a, b) => a.MOQ.localeCompare(b.MOQ)} />
                            <Table.Column title="Availability" dataIndex="Availability"
                                sorter={(a, b) => a.Availability.localeCompare(b.Availability)} />
                            <Table.Column title="State" dataIndex="State"
                                sorter={(a, b) => a.State.localeCompare(b.State)} />
                            <Table.Column title="Modules Per Pallet" dataIndex="ModulesPerPallet"
                                sorter={(a, b) => a.ModulesPerPallet.localeCompare(b.ModulesPerPallet)} />
                            <Table.Column title="Modules Per 53' FTL" dataIndex="FTL"
                                sorter={(a, b) => a.FTL.localeCompare(b.FTL)} />
                            <Table.Column align={'center'} title="Spreadsheet" render={(j) => {
                                if (j.Link) {
                                    return (
                                        <a href={j.Link} target={'_blank'} style={{ padding: '4px 15px' }}
                                            className='btn-back-dashboard'>PDF</a>
                                    )
                                } else
                                    return null
                            }} />
                        </Table>
                        
                       
                        <div className="table-bottom">

                        <div className="button-container">
        <a href="tel:+1234567890">
            <button className="center-button">Call Sales</button>
        </a>
        <a href="mailto:info@paneldeals.com">
            <button className="center-button">Request a Quote</button>
        </a>
    </div>
                       

                            <p>1- Pmax in watts (W) at Standard Testing Conditions (STC). Provided for reference only.
                                For detailed specifications, refer to the manufacturer datasheet.</p>
                            <p>2- Shown as $/Watt. Price reflects a 2.5% cash discount, applicable only when paying by
                                ACH transfer, wire transfer, or physical check. Not all items are available by the
                                container. Some items include special manufacturer pricing that can’t be displayed here.
                                Pricing is subject to change without notice.</p>
                            <p>3- Quantity and availability are subject to order confirmation.</p>
                            <p>4- Items marked with an asterisk (*) are shipped on oversized pallets. Some items may be
                                shipped on partial pallets when there is less than a full pallet quantity.</p>
                        </div>
                    </div>
                    <div className="content-card" id='inverters'>
                        <div className="table-search">
                            <div className="panel-card-heading">
                                <img src={INVERTER_ICON_LARGE} alt="" />
                                <h2>PV Solar Inverter</h2>
                            </div>
                        </div>
                        <div className="table-filter">
                            <div className="row">
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Manufacturer</label>
                                        <select name="manufacturer" id="manufacturer" onChange={(e) => {
                                            let value = e.target.value;
                                            if (value) {
                                                const filtered = inverterFilter.filter((item) => item.Manufacturer.toLowerCase().includes(value.trim().toLowerCase()));
                                                setInverterData(filtered);
                                            } else {
                                                setInverterData(inverterFilter)
                                            }
                                        }}>
                                            <option value="">All</option>
                                            {
                                                inverterMan.map((m, i) => {
                                                    return (
                                                        <option value={m.Manufacturer}>{m.Manufacturer}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                {/*<div className="col-3">*/}
                                {/*    <div className="form-group">*/}
                                {/*        <label>Price Per Watt</label>*/}
                                {/*        <div className="row" style={{marginTop: 0}}>*/}
                                {/*            <input type="text" style={{width: '48%', marginRight: '2%'}}*/}
                                {/*                   id={'inverterPriceMin'}*/}
                                {/*                   placeholder={'0.000'} onChange={(e) => {*/}
                                {/*                let min = e.target.value;*/}
                                {/*                let max = $('#inverterPriceMax').val();*/}
                                {/*                if (min && max) {*/}
                                {/*                    const filtered = inverterFilter.filter((item) => parseFloat(item.Price.replace('$', '')) >= parseFloat(min) && parseFloat(item.Price.replace('$', '')) <= parseFloat(max));*/}
                                {/*                    setInverterData(filtered);*/}
                                {/*                } else if (min) {*/}
                                {/*                    const filtered = inverterFilter.filter((item) => parseFloat(item.Price.replace('$', '')) >= parseFloat(min));*/}
                                {/*                    setInverterData(filtered);*/}
                                {/*                }*/}
                                {/*            }}/>*/}
                                {/*            <input type="text" style={{width: '48%'}} id={'inverterPriceMax'}*/}
                                {/*                   placeholder={''} onChange={(e) => {*/}
                                {/*                let max = e.target.value;*/}
                                {/*                let min = $('#inverterPriceMin').val();*/}
                                {/*                if (min && max) {*/}
                                {/*                    const filtered = inverterFilter.filter((item) => parseFloat(item.Price.replace('$', '')) >= parseFloat(min) && parseFloat(item.Price.replace('$', '')) <= parseFloat(max));*/}
                                {/*                    setInverterData(filtered);*/}
                                {/*                } else if (max) {*/}
                                {/*                    const filtered = inverterFilter.filter((item) => parseFloat(item.Price.replace('$', '')) >= parseFloat(max));*/}
                                {/*                    setInverterData(filtered);*/}
                                {/*                }*/}
                                {/*            }}/>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Additional Filters</label>
                                        <select name="additionalFilter" id="additionalFilter" onChange={(e) => {
                                            let value = e.target.value;
                                            if (value) {
                                                const filtered = inverterFilter.filter((item) => item.Availability.toLowerCase().includes(value.trim().toLowerCase()));
                                                setInverterData(filtered);
                                            } else {
                                                setInverterData(inverterFilter);
                                            }
                                        }}>
                                            <option value="">All</option>
                                            <option value="Available Now">Available Now</option>
                                            <option value="Last Stock">Last Stock</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>&nbsp;&nbsp;&nbsp;</label>
                                        <button className='btn-back-dashboard' onClick={() => {
                                            $('#inverterPriceMin').val('');
                                            $('#inverterPriceMax').val('');
                                            $('select[name="manufacturer"]').eq(1).val("");
                                            $('select[name="additionalFilter"]').eq(1).val("");
                                            setInverterData(inverterFilter)
                                        }}>Clear Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Table dataSource={inverterData} pagination={{ pageSize: 10 }}
                            loading={isLoading}
                            rowHoverable={true} style={{ marginTop: 20, overflowX: "auto" }}>
                            <Table.Column title="#" width={70} render={(j, r, index) => {
                                return (<span>{index + 1}</span>)
                            }} />

                            <Table.Column title="Manufacturer" dataIndex="Manufacturer"
                                sorter={(a, b) => a.Manufacturer.localeCompare(b.Manufacturer)} />
                            <Table.Column title="Manufacturer Part Number" dataIndex="PartNo"
                                sorter={(a, b) => a.PartNo.localeCompare(b.PartNo)} />
                            <Table.Column title="SKU" dataIndex="SKU" sorter={(a, b) => a.SKU.localeCompare(b.SKU)} />
                            <Table.Column title="Price" dataIndex="Price"
                                sorter={(a, b) => a.Price.localeCompare(b.Price)} />
                            <Table.Column title="Quantity" dataIndex="Quantity"
                                sorter={(a, b) => a.Quantity.localeCompare(b.Quantity)} />
                            <Table.Column title="MOQ" dataIndex="MOQ" sorter={(a, b) => a.MOQ.localeCompare(b.MOQ)} />
                            <Table.Column title="Availability" dataIndex="Availability"
                                sorter={(a, b) => a.Availability.localeCompare(b.Availability)} />
                            <Table.Column title="State" dataIndex="State"
                                sorter={(a, b) => a.State.localeCompare(b.State)} />
                            <Table.Column title="Max DC Input" dataIndex="DCInput"
                                sorter={(a, b) => a.DCInput.localeCompare(b.DCInput)} />
                            <Table.Column title="Rated AC Input Power" dataIndex="OutputPower"
                                sorter={(a, b) => a.OutputPower.localeCompare(b.OutputPower)} />
                            <Table.Column title="Rated AC Input Voltage" dataIndex="AcOutput"
                                sorter={(a, b) => a.AcOutput.localeCompare(b.AcOutput)} />
                            <Table.Column align={'center'} title="Spreadsheet" render={(j) => {
                                if (j.Link) {
                                    return (
                                        <a href={j.Link} target={'_blank'} style={{ padding: '4px 15px' }}
                                            className='btn-back-dashboard'>PDF</a>
                                    )
                                } else
                                    return null
                            }} />
                        </Table>
                        <div className="table-bottom">
                        <div className="button-container">
        <a href="tel:+1234567890">
            <button className="center-button">Call Sales</button>
        </a>
        <a href="mailto:info@paneldeals.com">
            <button className="center-button">Request a Quote</button>
        </a>
    </div>
                            <p>1- Price reflects a 2.5% cash discount, applicable only when paying by ACH transfer, wire
                                transfer, or physical check. Some items include special manufacturer pricing that can’t
                                be displayed here. Pricing is subject to change without notice.</p>
                            <p>2- Quantity and availability are subject to order confirmation.</p>
                            <p>3- Provided for reference only. For detailed specifications, refer to the manufacturer
                                datasheet.</p>
                        </div>
                    </div>
                    <div className="content-card" id='storages'>
                        <div className="table-search">
                            <div className="panel-card-heading">
                                <img src={STORAGE_ICON_LARGE} alt="" />
                                <h2>Energy Storage</h2>
                            </div>
                        </div>
                        <div className="table-filter">
                            <div className="row">
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Manufacturer</label>
                                        <select name="manufacturer" id="manufacturer" onChange={(e) => {
                                            let value = e.target.value;
                                            if (value) {
                                                const filtered = energyStorageFilter.filter((item) => item.Manufacturer.toLowerCase().includes(value.trim().toLowerCase()));
                                                setEnergyStorageData(filtered);
                                            } else {
                                                setEnergyStorageData(energyStorageFilter)
                                            }
                                        }}>
                                            <option value="">All</option>
                                            {
                                                storageMan.map((m, i) => {
                                                    return (
                                                        <option value={m.Manufacturer}>{m.Manufacturer}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Additional Filters</label>
                                        <select name="additionalFilter" id="additionalFilter" onChange={(e) => {
                                            let value = e.target.value;
                                            if (value) {
                                                const filtered = energyStorageFilter.filter((item) => item.Availability.toLowerCase().includes(value.trim().toLowerCase()));
                                                setEnergyStorageData(filtered);
                                            } else {
                                                setEnergyStorageData(energyStorageFilter);
                                            }
                                        }}>
                                            <option value="">All</option>
                                            <option value="Available Now">Available Now</option>
                                            <option value="Last Stock">Last Stock</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>&nbsp;&nbsp;&nbsp;</label>
                                        <button className='btn-back-dashboard' onClick={() => {
                                            $('select[name="manufacturer"]').eq(2).val("");
                                            $('select[name="additionalFilter"]').eq(2).val("");
                                            setEnergyStorageData(energyStorageFilter)
                                        }}>Clear Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Table dataSource={energyStorageData} pagination={{ pageSize: 10 }}
                            loading={isLoading}
                            rowHoverable={true} style={{ marginTop: 20, overflowX: "auto" }}>
                            <Table.Column title="#" width={70} render={(j, r, index) => {
                                return (<span>{index + 1}</span>)
                            }} />

                            <Table.Column title="Manufacturer" dataIndex="Manufacturer"
                                sorter={(a, b) => a.Manufacturer.localeCompare(b.Manufacturer)} />
                            <Table.Column title="Manufacturer Part Number" dataIndex="PartNo"
                                sorter={(a, b) => a.PartNo.localeCompare(b.PartNo)} />
                            <Table.Column title="SKU" dataIndex="SKU" sorter={(a, b) => a.SKU.localeCompare(b.SKU)} />
                            <Table.Column title="Price" dataIndex="Price"
                                sorter={(a, b) => a.Price.localeCompare(b.Price)} />
                            <Table.Column title="Quantity" dataIndex="Quantity"
                                sorter={(a, b) => a.Quantity.localeCompare(b.Quantity)} />
                            <Table.Column title="MOQ" dataIndex="MOQ" sorter={(a, b) => a.MOQ.localeCompare(b.MOQ)} />
                            <Table.Column title="Availability" dataIndex="Availability"
                                sorter={(a, b) => a.Availability.localeCompare(b.Availability)} />
                            <Table.Column title="State" dataIndex="State"
                                sorter={(a, b) => a.State.localeCompare(b.State)} />
                            <Table.Column title="Nominal Voltage" dataIndex="Voltage"
                                sorter={(a, b) => a.Voltage.localeCompare(b.Voltage)} />
                            <Table.Column title="Total Energy Capacity" dataIndex="Capacity"
                                sorter={(a, b) => a.Capacity.localeCompare(b.Capacity)} />
                            <Table.Column align={'center'} title="Spreadsheet" render={(j) => {
                                if (j.Link) {
                                    return (
                                        <a href={j.Link} target={'_blank'} style={{ padding: '4px 15px' }}
                                            className='btn-back-dashboard'>PDF</a>
                                    )
                                } else
                                    return null
                            }} />
                        </Table>
                        <div className="table-bottom">
                        <div className="button-container">
        <a href="tel:+1234567890">
            <button className="center-button">Call Sales</button>
        </a>
        <a href="mailto:info@paneldeals.com">
            <button className="center-button">Request a Quote</button>
        </a>
    </div>
                            <p>1- Price reflects a 2.5% cash discount, applicable only when paying by ACH transfer, wire
                                transfer, or physical check. Some items include special manufacturer pricing that can’t
                                be displayed here. Pricing is subject to change without notice.</p>
                            <p>2- Quantity and availability are subject to order confirmation.</p>
                            <p>3- Provided for reference only. For detailed specifications, refer to the manufacturer
                                datasheet.</p>
                        </div>
                    </div>
                    <div className="content-card" id={'accessories'}>
                        <div className="table-search">
                            <div className="panel-card-heading">
                                <img src={ACCESSORIES_ICON_LARGE} alt="" />
                                <h2>Accessories</h2>
                            </div>
                        </div>
                        <div className="table-filter">
                            <div className="row">
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Manufacturer</label>
                                        <select name="manufacturer" id="manufacturer" onChange={(e) => {
                                            let value = e.target.value;
                                            if (value) {
                                                const filtered = accessoriesFilter.filter((item) => item.Manufacturer.toLowerCase().includes(value.trim().toLowerCase()));
                                                setAccessoriesData(filtered);
                                            } else {
                                                setAccessoriesData(accessoriesFilter)
                                            }
                                        }}>
                                            <option value="">All</option>
                                            {
                                                accessoriesMan.map((m, i) => {
                                                    return (
                                                        <option value={m.Manufacturer}>{m.Manufacturer}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Accessory Category</label>
                                        <select name="category" id="category" onChange={(e) => {
                                            let value = e.target.value;
                                            if (value) {
                                                const filtered = accessoriesFilter.filter((item) => item.Category.toLowerCase().includes(value.trim().toLowerCase()));
                                                setAccessoriesData(filtered);
                                            } else {
                                                setAccessoriesData(accessoriesFilter);
                                            }
                                        }}>
                                            <option value="">All</option>
                                            <option value="Inverter Accessories">Inverter Accessories</option>
                                            <option value="Storage Accessories">Storage Accessories</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>Additional Filters</label>
                                        <select name="additionalFilter" id="additionalFilter" onChange={(e) => {
                                            let value = e.target.value;
                                            if (value) {
                                                const filtered = accessoriesFilter.filter((item) => item.Availability.toLowerCase().includes(value.trim().toLowerCase()));
                                                setAccessoriesData(filtered);
                                            } else {
                                                setAccessoriesData(accessoriesFilter);
                                            }
                                        }}>
                                            <option value="">All</option>
                                            <option value="Available Now">Available Now</option>
                                            <option value="Last Stock">Last Stock</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <label>&nbsp;&nbsp;&nbsp;</label>
                                        <button className='btn-back-dashboard' onClick={() => {
                                            $('select[name="category"]').eq(0).val("");
                                            $('select[name="manufacturer"]').eq(3).val("");
                                            $('select[name="additionalFilter"]').eq(3).val("");
                                            setAccessoriesData(accessoriesFilter)
                                        }}>Clear Filter
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Table dataSource={accessoriesData} pagination={{ pageSize: 10 }}
                            loading={isLoading}
                            rowHoverable={true} style={{ marginTop: 20, overflowX: "auto" }}>
                            <Table.Column title="#" width={70} render={(j, r, index) => {
                                return (<span>{index + 1}</span>)
                            }} />

                            <Table.Column title="Manufacturer" dataIndex="Manufacturer"
                                sorter={(a, b) => a.Manufacturer.localeCompare(b.Manufacturer)} />
                            <Table.Column title="Manufacturer Part Number" dataIndex="PartNo"
                                sorter={(a, b) => a.PartNo.localeCompare(b.PartNo)} />
                            <Table.Column title="SKU" dataIndex="SKU" sorter={(a, b) => a.SKU.localeCompare(b.SKU)} />
                            <Table.Column title="Price" dataIndex="Price"
                                sorter={(a, b) => a.Price.localeCompare(b.Price)} />
                            <Table.Column title="Quantity" dataIndex="Quantity"
                                sorter={(a, b) => a.Quantity.localeCompare(b.Quantity)} />
                            <Table.Column title="MOQ" dataIndex="MOQ" sorter={(a, b) => a.MOQ.localeCompare(b.MOQ)} />
                            <Table.Column title="Availability" dataIndex="Availability"
                                sorter={(a, b) => a.Availability.localeCompare(b.Availability)} />
                            <Table.Column title="State" dataIndex="State"
                                sorter={(a, b) => a.State.localeCompare(b.State)} />
                            <Table.Column title="Category" dataIndex="Category"
                                sorter={(a, b) => a.Category.localeCompare(b.Category)} />
                            <Table.Column align={'center'} title="Spreadsheet" render={(j) => {
                                if (j.Link) {
                                    return (
                                        <a href={j.Link} target={'_blank'} style={{ padding: '4px 15px' }}
                                            className='btn-back-dashboard'>PDF</a>
                                    )
                                } else
                                    return null
                            }} />
                        </Table>
                        <div className="table-bottom">
                        <div className="button-container">
        <a href="tel:+1234567890">
            <button className="center-button">Call Sales</button>
        </a>
        <a href="mailto:info@paneldeals.com">
            <button className="center-button">Request a Quote</button>
        </a>
    </div>
                            <p>1- Price reflects a 2.5% cash discount, applicable only when paying by ACH transfer, wire
                                transfer, or physical check. Some items include special manufacturer pricing that can’t
                                be displayed here. Pricing is subject to change without notice.</p>
                            <p>2- Quantity and availability are subject to order confirmation.</p>
                        </div>
                    </div>
                    <div className="content-card" id={'faqs'}>
                        <div className="table-search">
                            <div className="panel-card-heading">
                                <h2>FAQs</h2>
                            </div>
                        </div>
                        <div className="faqs">
                            <Collapse ghost items={faqs} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
